(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.LoadingOverlay = {
        show: function() {
            $('#loading-overlay').removeClass('d-none');
        },
        hide: function() {
            $('#loading-overlay').addClass('d-none');
        }
    };

})));
